class LogoSlider extends HTMLElement{
    constructor() {
        super();

        this.container = this.querySelector('.marquee-container');
        this.marqueeContent = this.querySelector('.marquee-content');
        
        this.slider = this.slider.bind(this);
    }
    connectedCallback(){
        // 初始化一次
        this.slider()
        window.addEventListener('resize', this.slider);
        window.addEventListener('load', this.slider);
    }
    slider(){
        const contentWidth = this.container.offsetWidth;
        const containerWidth = this.marqueeContent.offsetWidth / 2;
        const totalDistance = contentWidth + containerWidth; 
    }
    disconnectedCallback() {
        // 移除事件，防止内存泄漏
        window.removeEventListener('resize', this.slider);
    }
}
customElements.define('logo-slider', LogoSlider);